import * as React from 'react';
import * as NEA from 'fp-ts/NonEmptyArray';
import * as A from 'fp-ts/Array';
import * as O from 'fp-ts/Option';
import { pipe } from 'fp-ts/lib/function';
import { contramap } from 'fp-ts/lib/Ord';
import { PlayerVoteCountFragmentFragment } from '../generated/graphql';
import { getVoteLabel } from '../pages/Votes/voteLabelLookup';
import { PlayerNameWithAvatar } from '../pages/Match/components/PlayerNameWithAvatar';
import { byVoteType, byVoteTypeName } from '../utils/sorting';
import { getEqNode } from '../utils/comparison';

interface Props {
  winners: NEA.NonEmptyArray<PlayerVoteCountFragmentFragment>;
  isSignedIn?: boolean;
}

export const byWinnerVoteType = contramap(
  ([voteType]: [string, unknown]) => voteType,
)(byVoteTypeName);

export const VoteWinners: React.FC<Props> = ({ winners, isSignedIn }) => {
  const voteTypes = pipe(
    winners,
    A.map(({ voteType }) => voteType),
    A.uniq(getEqNode()),
    A.sort(byVoteType),
  );

  return (
    <div className={`grid ${voteTypes.length > 1 ? 'grid-cols-2' : ''} gap-4`}>
      {pipe(
        voteTypes,
        A.filterMap((voteType) => {
          const winnersForVoteType = winners.filter(
            (winner) => winner.voteType.id === voteType.id,
          );

          if (A.isEmpty(winnersForVoteType)) {
            return O.none;
          }

          return O.some(
            <div key={voteType.id} className="text-center">
              <div className="text-4xl pb-3">{voteType.emoji}</div>
              <div className="text-xs mb-2">{getVoteLabel(voteType.name)}</div>
              <div className="space-y-2 inline-block">
                {winnersForVoteType.map((winner) => (
                  <PlayerNameWithAvatar
                    key={winner.player.id}
                    player={winner.player}
                    linkToPlayer={isSignedIn}
                  />
                ))}
              </div>
            </div>,
          );
        }),
      )}
    </div>
  );
};
